import React, {
  useContext,
  useEffect,
  useMemo,
  useState,
  Suspense,
} from 'react';
import LazyLoadContext from '@client/helperComponents/context/LazyLoadContext';

const defaultOptions = {
  loading: () => null,
};

export default function universalWithLazyReducers(importPromise, options) {
  const resolvedOptions = { ...defaultOptions, ...(options || {}) };
  const isServer = typeof window === 'undefined';

  function ClientWrapper(props) {
    const { injectReducer } = useContext(LazyLoadContext) || {};
    const [Loaded, setLoaded] = useState(null);
    const [isHydrated, setIsHydrated] = useState(false);

    useEffect(() => {
      setIsHydrated(true);
      let mounted = true;
      importPromise().then((module) => {
        try {
          if (injectReducer) {
            if (module.reducer) {
              injectReducer(module.reducer.name, module.reducer.reducer);
            }
            if (Array.isArray(module.reducers)) {
              module.reducers.forEach((r) => injectReducer(r.name, r.reducer));
            }
          }
        } catch (_) {}
        if (mounted) setLoaded(() => module.default || module);
      });
      return () => {
        mounted = false;
      };
    }, [injectReducer]);

    const Loading = useMemo(
      () => resolvedOptions.loading,
      [resolvedOptions.loading]
    );
    // Avoid rendering a visual fallback during hydration to keep markup identical
    if (!isHydrated) return null;
    if (!Loaded) return <Loading />;
    return <Loaded {...props} />;
  }

  return function UniversalWithLazyReducers(props) {
    if (isServer) return null;
    return (
      <Suspense fallback={null}>
        <ClientWrapper {...props} />
      </Suspense>
    );
  };
}
